import * as requestFromServer from "./normalCrud";
import { distributionNormalSlice, callTypes } from "./normalSlice";
import { actions as auth } from "../../../Auth/_redux/authRedux";
import { toastOption } from "../../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = distributionNormalSlice;

export const fetchDistributionNormals = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findDistributionNormal(queryParams)
    .then((response) => {
      const { data } = response.data;
      dispatch(actions.distributionNormalsFetched(data));
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const submitDistribution = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .submitDistribution(queryParams)
    .then((response) => {
      const { data } = response.data;
      dispatch(actions.distributionNormalReload());
      return data;
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
